<template>
      <div no-body class="lku-mr"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
          <b-input-group >
            <b-input-group-prepend><label>Requisition</label></b-input-group-prepend>
            <b-form-input v-model="tblData.requestno" @keyup.13.native="refresh()" size="sm" placeholder="Request Number"></b-form-input>
            <b-input-group-prepend><span class="p-2">Remark</span></b-input-group-prepend>
            <b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" size="sm" placeholder="Description"  style="width: 40% !important;"></b-form-input>
          </b-input-group>

          <b-input-group >
            <b-input-group-prepend><label>Request By</label></b-input-group-prepend>
            <b-form-input v-model="tblData.createby" @keyup.13.native="refresh()" size="sm" placeholder="Request By"></b-form-input>
            <b-input-group-prepend><span class="p-2">Progress Status</span></b-input-group-prepend>
            <b-form-select v-model="tblData.pr" :plain="true" :options="dataList.mrProgress" size="sm"></b-form-select>
            <b-input-group-prepend><span class="p-2">User Receipt</span></b-input-group-prepend>
            <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.openStatus" size="sm"></b-form-select>
            <b-input-group-append>
                <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear </b-button>
            </b-input-group-append>
          </b-input-group>

      </b-row>
        <b-table
          class="mb-0"
          ref="tblMrSr"
          responsive
          striped hover small 
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
          <template v-slot:cell(requestno)="data">
            {{ data.item.requestno}}  <span v-if="data.item.barter==1" style="background-color:yellow;">&nbsp; (BARTER) &nbsp;</span>
          </template>
          <template v-slot:cell(requestdate)="data">
            {{ data.item.requestdate | moment("DD MMM YYYY") }}
          </template>
          <template v-slot:cell(quantity)="data">
              {{data.item.quantity}} {{data.item.invunitom}}
          </template>
          <template v-slot:cell(itemname)="data">
              <div style="width:300px;"><strong>{{data.item.itemname}}</strong> <br>
                  <pre>{{data.item.description}}</pre>                
              </div>
          </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <input type="number" style="width:80px;" v-model="tblData.limit"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-mr {
    pre {
        white-space: pre-wrap;       /* css-3 */
        white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
        white-space: -pre-wrap;      /* Opera 4-6 */
        white-space: -o-pre-wrap;    /* Opera 7 */
        word-wrap: break-word;       /* Internet Explorer 5.5+ */
    }    
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import mr from "../../apis/logistic_mr";
import dropdown from "../../data/dropdown";
export default {
  data() {
    return {
      items:[],
      fields: [
          {
            key: "requestno",
            thStyle: "width:100px",
            label: "Request Number",
            sortable: true
          },
          {
            key: "requestdate",
            thStyle: "width:90px",
            label: "Request Date",
            sortable: true
          },
          {
            key: "createby",
            label: "Request By",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "itemname",
            label: "Request Item Name/Description",
            sortable: true
          },
          {
            key: "nmcategory",
            label: "Item Category",
            thStyle: "width:120px",
            sortable: true
          },
          // {
          //   key: "jasa",
          //   thStyle: "width:80px",
          //   label: "Service/ Material",
          //   sortable: true
          // },
          {
            key: "quantity",
            label: "Qty. Request",
            thStyle: "width:100px",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "qtyissued",
            label: "Qty. Issued",
            thStyle: "width:60px",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "qtyOstand",
            label: "Qty. Outstand",
            thStyle: "width:60px",
            tdClass: "text-center",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 10,
        total: 0,
        sortBy: 'requestdate',
        sortDesc: true,
        outstand:'1', approved:1,pr:'0' 
      },
      dataList: {
        openStatus: dropdown.openClose,
        approvalStatus: dropdown.approvalStatus,
        mrProgress: dropdown.mrProgress
      },      
      lkuLoading:false
    };
  },
  props: ["filter","pr"],
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
      this.tblData.pr = this.pr || '';
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      if(this.filter){
        for (const key in this.filter) {
          this.tblData[key]= encodeURIComponent(this.filter[key])
        }
      }
      
      this.lkuLoading=true;
      const list = await mr.list(this.tblData);          
      this.lkuLoading=false;
      return list;
    },

    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.uraian=  '';
        this.tblData.requestno=  '';
        this.tblData.createby=  '';
        this.refresh();
    },    
    refresh: async function() {
      // this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // console.log('page ',this.tblData.page) ; 
      // this.items= await mr.list(this.tblData);    
      // console.log('rows ',this.items) ; 
      this.$refs.tblMrSr.refresh();
    }
  }
};
</script>
